import { FC, forwardRef, Ref } from "react";
import { IonRadio } from '@ionic/react';
import { AllieIonRadioProps } from "./IonRadio.types";

export const AllieIonRadio: FC<AllieIonRadioProps> = forwardRef(
  ({...props} : AllieIonRadioProps, ref) => <IonRadio {...props} ref={ref as Ref<HTMLIonRadioElement>} />
);
